// import React from 'react'

// const TestingOcancerImagesShiftFromFossila2 = () => {
//   return (
//     <div>TestingOcancerImagesShiftFromFossila2</div>
//   )
// }

// App.js - Fixed Image Loading + Blue Core Limbs Wireframe
import React, { useState, useRef } from "react";
import * as tf from "@tensorflow/tfjs";

function TestingOcancerImagesShiftFromFossila2() {
  const [imageSrc, setImageSrc] = useState(null);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const originalCanvasRef = useRef(null);
  const wireframeCanvasRef = useRef(null);
  const imageRef = useRef(null);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setIsImageLoaded(false); // reset
    const reader = new FileReader();
    reader.onload = (e) => {
      setImageSrc(e.target.result);
      // Image will trigger onLoad once it's ready
    };
    reader.readAsDataURL(file);
  };

  const onImageLoad = () => {
    setIsImageLoaded(true);
    // Optional: auto-process when loaded
    // processImage();
  };

  const processImage = async () => {
    if (!isImageLoaded || !imageRef.current) return;

    const img = imageRef.current;
    const w = img.naturalWidth;
    const h = img.naturalHeight;

    if (w === 0 || h === 0) {
      alert("Image not loaded yet — please wait a moment and try again.");
      return;
    }

    // Set canvas sizes
    const origCanvas = originalCanvasRef.current;
    const wireCanvas = wireframeCanvasRef.current;
    origCanvas.width = w;
    origCanvas.height = h;
    wireCanvas.width = w;
    wireCanvas.height = h;

    // Draw original image to BOTH canvases
    const origCtx = origCanvas.getContext("2d");
    origCtx.drawImage(img, 0, 0, w, h);

    // const wireCtx = wireCanvas.getContext("2d");
    // wireCtx.drawImage(img, 0, 0, w, h); // ← base layer is the original photo

    // ────────────────────────────────────────────────────────────────
    // Your TF.js edge detection (unchanged)
    let tensor = tf.browser.fromPixels(img, 1).toFloat().div(255);

    const gaussianValues = [
      1 / 256,
      4 / 256,
      6 / 256,
      4 / 256,
      1 / 256,
      4 / 256,
      16 / 256,
      24 / 256,
      16 / 256,
      4 / 256,
      6 / 256,
      24 / 256,
      36 / 256,
      24 / 256,
      6 / 256,
      4 / 256,
      16 / 256,
      24 / 256,
      16 / 256,
      4 / 256,
      1 / 256,
      4 / 256,
      6 / 256,
      4 / 256,
      1 / 256,
    ];
    const gaussianKernel = tf.tensor4d(gaussianValues, [5, 5, 1, 1]);

    let blurred = tf.conv2d(tensor.expandDims(-1), gaussianKernel, 1, "same");
    blurred = tf.squeeze(blurred, [3]);

    tf.dispose(gaussianKernel);

    const sobelX = tf.tensor3d([
      [[-1], [0], [1]],
      [[-2], [0], [2]],
      [[-1], [0], [1]],
    ]);
    const sobelY = tf.tensor3d([
      [[-1], [-2], [-1]],
      [[0], [0], [0]],
      [[1], [2], [1]],
    ]);

    let gx = tf.conv2d(
      blurred.expandDims(-1),
      sobelX.expandDims(-1),
      1,
      "same"
    );
    let gy = tf.conv2d(
      blurred.expandDims(-1),
      sobelY.expandDims(-1),
      1,
      "same"
    );

    gx = tf.squeeze(gx);
    gy = tf.squeeze(gy);

    const mag = tf.sqrt(tf.add(tf.square(gx), tf.square(gy)));

    const maxMagData = await mag.max().data();
    const maxMagVal = maxMagData[0] + 1e-6;
    let normMag = mag.div(maxMagVal);

    let suppressed = normMag.clone();

    const strongThresh = 0.3;
    const weakThresh = 0.1;
    const strong = suppressed.greater(strongThresh);
    const weak = suppressed.greater(weakThresh).logicalAnd(strong.logicalNot());
    let binary = strong.logicalOr(weak).toFloat();

    // Edge ratio log
    const edgeRatio = await binary.mean().data();
    //console.log(`Edge pixel ratio: ${(edgeRatio[0] * 100).toFixed(2)}%`);

    // Dispose everything EXCEPT binary for now
    tf.dispose([
      tensor,
      blurred,
      gx,
      gy,
      mag,
      normMag,
      suppressed,
      sobelX,
      sobelY,
    ]);

    // ────────────────────────────────────────────────────────────────
    // Overlay blue wireframe on the second canvas (on top of the photo)
    const wireCtx = wireCanvas.getContext("2d");
    wireCtx.drawImage(img, 0, 0, w, h); // make sure original photo is base layer

    // Temp render edges as grayscale
    await tf.browser.toPixels(binary.squeeze(), wireCanvas);

    // Tint edges blue + make non-edges transparent
    const imageData = wireCtx.getImageData(0, 0, w, h);
    const data = imageData.data;

    for (let i = 0; i < data.length; i += 4) {
      if (data[i] > 180) {
        // adjust 180–220 depending on how strong edges appear
        data[i] = 0; // R
        data[i + 1] = 120; // G → blue
        data[i + 2] = 255; // B
        data[i + 3] = 220; // semi-transparent
      } else {
        data[i + 3] = 0; // transparent → original photo shows through
      }
    }

    wireCtx.putImageData(imageData, 0, 0);

    // console.log("Blue wireframe overlaid on original image");

    // NOW safe to dispose binary
    tf.dispose(binary);
  };

  return (
    <div
      style={{
        textAlign: "center",
        padding: "20px",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <h1>Tree Wireframe Tracer (Fixed Loading)</h1>
      <p>Upload a photo of a tree → see original + blue core limbs wireframe</p>

      <input
        type="file"
        accept="image/*"
        onChange={handleImageUpload}
        style={{
          margin: "15px 0",
          display: "block",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      />

      {imageSrc && (
        <>
          <img
            ref={imageRef}
            src={imageSrc}
            alt="Uploaded tree"
            onLoad={onImageLoad}
            style={{
              maxWidth: "90%",
              maxHeight: "500px",
              display: isImageLoaded ? "block" : "none",
              margin: "20px auto",
              border: "1px solid #ddd",
              borderRadius: "8px",
            }}
          />

          {isImageLoaded ? (
            <>
              <div style={{ margin: "20px 0" }}>
                <button
                  onClick={processImage}
                  style={{
                    padding: "10px 24px",
                    fontSize: "16px",
                    backgroundColor: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                  }}
                >
                  Generate Blue Wireframe
                </button>
              </div>

              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: "30px",
                }}
              >
                <div>
                  <h3>Original Image</h3>
                  <canvas
                    ref={originalCanvasRef}
                    style={{ border: "1px solid #ccc", borderRadius: "6px" }}
                  />
                </div>

                <div>
                  <h3>Blue Core Limbs Wireframe</h3>
                  <canvas
                    ref={wireframeCanvasRef}
                    style={{ border: "1px solid #ccc", borderRadius: "6px" }}
                  />
                </div>
              </div>
            </>
          ) : (
            <p style={{ color: "#666", marginTop: "20px" }}>
              Loading image... please wait
            </p>
          )}
        </>
      )}
    </div>
  );
}

export default TestingOcancerImagesShiftFromFossila2;
